import { AgentRoomPanel } from "../dashboard/AgentRoomPanel";

/** SIMO-AGENT-ROOM-LIVE-1 — Desktop-Surface für den Live-Agent-Room. */
export function SimoTAgentRoomView(): JSX.Element {
  return <AgentRoomPanel />;
}
